export var IconButtonSize;
(function (IconButtonSize) {
    IconButtonSize["medium"] = "medium";
    IconButtonSize["small"] = "small";
})(IconButtonSize || (IconButtonSize = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["large"] = "large";
    ButtonSize["medium"] = "medium";
    ButtonSize["small"] = "small";
})(ButtonSize || (ButtonSize = {}));
export var ColorTypes;
(function (ColorTypes) {
    ColorTypes["Inherit"] = "inherit";
    ColorTypes["Primary"] = "primary";
    ColorTypes["Secondary"] = "secondary";
    ColorTypes["Default"] = "default";
})(ColorTypes || (ColorTypes = {}));
export var ExtendedColorTypes;
(function (ExtendedColorTypes) {
    ExtendedColorTypes["Inherit"] = "inherit";
    ExtendedColorTypes["Primary"] = "primary";
    ExtendedColorTypes["Secondary"] = "secondary";
    ExtendedColorTypes["Action"] = "action";
    ExtendedColorTypes["Error"] = "error";
    ExtendedColorTypes["Disabled"] = "disabled";
})(ExtendedColorTypes || (ExtendedColorTypes = {}));
export var HorizontalPosition;
(function (HorizontalPosition) {
    HorizontalPosition["Left"] = "left";
    HorizontalPosition["Right"] = "right";
})(HorizontalPosition || (HorizontalPosition = {}));
export var InputState;
(function (InputState) {
    InputState["DEFAULT"] = "default";
    InputState["LOCKED"] = "locked";
    InputState["DISABLED"] = "disabled";
    InputState["ERROR"] = "error";
})(InputState || (InputState = {}));
//# sourceMappingURL=types.js.map